import { useMutation as useRQMutation } from "react-query";

import type {
  MutationBaseFunction,
  UseMutationBaseOptions,
  UseBaseMutationResult,
} from "./types";

export function useBaseMutation<
  TData = unknown,
  TError = unknown,
  TVariables = void,
  TContext = unknown,
>(
  mutationFn: MutationBaseFunction<TData, TVariables>,
  options?: UseMutationBaseOptions<TData, TError, TVariables, TContext>,
): UseBaseMutationResult<TData, TError, TVariables, TContext> {
  return useRQMutation(
    mutationFn,
    options
      ? {
          onSuccess: options.onSuccess,
          onError: options.onError,
          onMutate: options.onMutate,
        }
      : options,
  );
}
